import React, { Fragment } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';

const CommonDropDown = ({ item }) => {
  return (
    <ButtonGroup>
      <Dropdown>
        <Btn color={` dropbtn ${item.btnclass} btn-square d-flex gap-2`}>
          {item.btnText}
          <span>
            <i className='icofont icofont-arrow-down '></i>
          </span>
        </Btn>
        <DropdownMenu className='dropdown-content'>
          {item.items.map((dropdownItem, i) => (
            <Fragment key={i}>
              {dropdownItem.item ? <DropdownItem href='#'>{dropdownItem.item}</DropdownItem> : ''}
              {dropdownItem.divider ? <DropdownItem divider /> : ''}
            </Fragment>
          ))}
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};

export default CommonDropDown;
